
import React from "react";
import PmInterviewQuestions from '../Components/Dashboard/Resource-Center/PmInterviewQuestions';
import {
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import SessionTimeoutRedirect from '../Components/Common/SessionTimeoutRedirect'
const AuthPmInterviewQuestions = () => {
   const useAuth=()=>{
    const user=localStorage.getItem('user_id')
    const token = document.cookie.replace(/(?:(?:^|.*;\s*)token\s*=\s*([^;]*).*$)|^.*$/, '$1');

    if(token){
      return true
    } else {
      localStorage.clear()
      return false
    }
  }
  const auth = useAuth();
  return auth ? <PmInterviewQuestions /> : <SessionTimeoutRedirect />
}
export default AuthPmInterviewQuestions;


